'use client';

import { useCartStore } from '@/stores';
import type { Product } from '@/types';

interface AddToCartButtonProps {
  product: Product;
  disabled?: boolean;
}

export function AddToCartButton({ product, disabled }: AddToCartButtonProps) {
  const addItem = useCartStore((s) => s.addItem);

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => addItem(product)}
      className="w-full py-3 px-6 rounded-xl font-semibold text-white bg-[#7B42FF] hover:bg-[#6935d9] active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
    >
      В корзину
    </button>
  );
}
